import { Signer } from '.';
import { LockType } from '..';
export class DefaultSigner extends Signer {
    constructor(provider) {
        super();
        this.provider = provider;
    }
    async signMessages(messages) {
        const sigs = [];
        for (const message of messages) {
            // Determine if PW-Lock was used.
            const isPwLock = message.lock.identifyLockType() === LockType.pw;
            // If PwLock, determine the lock hash based on LockType.pw.
            const lockType = isPwLock ? LockType.pw : null;
            const lockHash = this.provider.address.toLockScript(lockType).toHash();
            // Attempt to sign only for messages matching the current lock hash.
            if (lockHash === message.lock.toHash()) {
                // Sign the message.
                sigs.push(await this.provider.sign(message));
            }
            else {
                sigs.push('0x');
            }
        }
        return sigs;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1zaWduZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2lnbmVycy9kZWZhdWx0LXNpZ25lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsTUFBTSxFQUFXLE1BQU0sR0FBRyxDQUFDO0FBR3BDLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxJQUFJLENBQUM7QUFFOUIsTUFBTSxPQUFPLGFBQWMsU0FBUSxNQUFNO0lBQ3ZDLFlBQTRCLFFBQWtCO1FBQzVDLEtBQUssRUFBRSxDQUFDO1FBRGtCLGFBQVEsR0FBUixRQUFRLENBQVU7SUFFOUMsQ0FBQztJQUVELEtBQUssQ0FBQyxZQUFZLENBQUMsUUFBbUI7UUFDcEMsTUFBTSxJQUFJLEdBQUcsRUFBRSxDQUFDO1FBQ2hCLEtBQUssTUFBTSxPQUFPLElBQUksUUFBUSxFQUFFO1lBQzlCLGlDQUFpQztZQUNqQyxNQUFNLFFBQVEsR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLGdCQUFnQixFQUFFLEtBQUssUUFBUSxDQUFDLEVBQUUsQ0FBQztZQUVqRSwyREFBMkQ7WUFDM0QsTUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7WUFDL0MsTUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLFFBQVEsQ0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBRXZFLG9FQUFvRTtZQUNwRSxJQUFJLFFBQVEsS0FBSyxPQUFPLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxFQUFFO2dCQUN0QyxvQkFBb0I7Z0JBQ3BCLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxJQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO2FBQzlDO2lCQUFNO2dCQUNMLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7YUFDakI7U0FDRjtRQUVELE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztDQUNGIn0=